import { AxiosError } from 'axios';

import { CONSULTANT_DATA_CENTER_DISCOVERY_API_URL } from '@/constants/apis';
import { apiManager } from '@/helpers/api.manager';
import { DiscoveryApiResponse } from '@/types/discovery.type';
import { ApiResponse } from '@/types/response.type';

export interface GetConsultantDiscoveryDataParams {
  page?: number;
  limit?: number;
}

const getConsultantDiscoveryData = async (
  params: GetConsultantDiscoveryDataParams = {}
): Promise<ApiResponse<DiscoveryApiResponse>> => {
  try {
    const response = await apiManager.get(
      CONSULTANT_DATA_CENTER_DISCOVERY_API_URL,
      {
        headers: { 'Content-Type': 'application/json' },
        params: {
          page: params.page ?? 1,
          limit: params.limit ?? 20,
        },
      }
    );

    if (response.status !== 200) {
      const error = response as unknown as AxiosError;
      return Promise.reject(error.response?.data);
    }

    return Promise.resolve(response.data);
  } catch (e) {
    return Promise.reject(e);
  }
};

export default getConsultantDiscoveryData;
